import { atom } from "jotai";
import { IChatCommand } from "../services/assetServices";

export const defaultChatCommand: IChatCommand = {
  action: '',
  entityType: '',
}

export const chatCommandContentsAtom = atom<IChatCommand>(defaultChatCommand);